module.exports = __webpack_public_path__ + "static/img/mshuiP2.37048ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/mshuiP2.jpg
// module id = kS9l
// module chunks = 0